// General validation messages
export const ERROR_REQUIRED = 'Required';
export const ERROR_SELECT_OPTION = 'Select an option';
export const ERROR_VALID_DATE = 'Enter a valid date';
export const ERROR_VALID_EMAIL = 'Enter a valid email address';
export const ERROR_VALID_MOBILE = 'Enter a valid mobile number';

// Name validation messages
export const ERROR_PATTERN_VALID_NAME =
  "Enter a valid input using only letters, spaces, hyphens (-), apostrophes ('), periods (.), or commas (,)";
export const ERROR_VALID_FAMILY_NAME = 'Family name must be included in full name';

// NRIC validation messages
export const ERROR_VALID_NRIC = 'Must contain 4 characters';

// Password validation messages
export const ERROR_SAME_PASSWORD = 'The Password does not match.';

// OTP validation messages
export const ERROR_VALID_OTP = 'Wrong OTP entered. Try again.';
export const MESSAGE_OTP_SENT = 'OTP Sent Successfully';

// Group/CG validation messages
export const ERROR_GROUP = 'Enter a valid CG';

// School name validation messages
export const ERROR_VALID_SCHOOL_NAME = 'Enter a valid school name';

// Stage of life validation messages
export const ERROR_VALID_STAGE_OF_LIFE = 'Only alphabetic characters and spaces allowed';
